module.exports = require("./fr-RW.js");